import { render } from "./Hero.vue?vue&type=template&id=739325fe&scoped=true"
import script from "./Hero.vue?vue&type=script&lang=js"
export * from "./Hero.vue?vue&type=script&lang=js"

import "./Hero.vue?vue&type=style&index=0&id=739325fe&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-739325fe"

export default script